<template>
  <div>
    <!-- Bottone Live Market -->
    <div class="button-container" v-if="type === 'nominale' && liveMarketExists">
      <div class="prize-text">REPORT LIVE MARKET</div>
      <div>
        <small class="fs-14">
          Integra alla Quotazione Quattroruote un'ampia e dettagliata analisi <br />
          del mercato degli annunci online del veicolo oggetto di valutazione.
        </small>
      </div>
      <button
        class="button-primary wtevent"
        :disabled="loadingLiveMarket"
        @click="onLiveMarketClick"
        data-event-click="quotauto.nominale.live-market.click"
        data-event-imps="quotauto.nominale.live-market.imps"
        ref="liveMarketButton"
      >
        <template v-if="!loadingLiveMarket">
          <span>ACQUISTA A </span>
          <span :class="promotions['live-market'].new ? 'line-through' : ''">
            {{ promotions['live-market'].standard }}€
          </span>
          <span v-if="promotions['live-market'].new"> {{ promotions['live-market'].new }}€ </span>
        </template>
        <loader v-else size="20px" />
      </button>
    </div>

    <!-- Bottone principale -->
    <div class="button-container">
      <div class="prize-text">
        {{ price }}
        <span
          v-if="type === 'live-market' || type === 'storica'"
          :class="promotions[type].new ? 'line-through' : ''"
        >
          {{ promotions[type].standard }}€
        </span>
        <span v-if="promotions[type].new && type !== 'nominale'">
          {{ promotions[type].new }}€
        </span>
      </div>
      <div v-if="type === 'nominale'" class="mr-45">
        <small class="fs-14">
          Sono il risultato delle più aggiornate tecniche di analisi statistica <br />
          e di accurate rilevazioni di mercato.
        </small>
      </div>
      <button
        :class="[
          {
            'button-buy-nominal': type === 'nominale',
            'button-primary': type !== 'nominale',
            disabledBtn: type === 'storica' && !isDateValid,
          },
          'wtevent',
          loadingMain ? 'bg-red' : '',
        ]"
        :disabled="loadingMain"
        @click="onMainClick"
        :data-event-click="`quotauto.${type}.click`"
        :data-event-imps="`quotauto.${type}.imps`"
        ref="mainButton"
      >
        <template v-if="!loadingMain">
          <span>{{ buttonText }}</span>
          <span v-if="type === 'nominale'" :class="promotions[type].new ? 'line-through' : ''">
            {{ promotions[type].standard }}€
          </span>
          <span v-if="promotions[type].new && type === 'nominale'">
            {{ promotions[type].new }}€
          </span>
        </template>
        <loader v-else size="20px" />
      </button>
    </div>
  </div>
</template>

<script>
import Loader from './Loader.vue';

export default {
  name: 'BuyQuotationBtn',
  components: { Loader },
  props: {
    type: { type: String, required: true },
    liveMarketExists: { type: Boolean, required: true },
    promotions: { type: Object, default: () => ({}) },
    isDateValid: { type: Boolean, default: false },
  },
  data() {
    return {
      loadingLiveMarket: false,
      loadingMain: false,
    };
  },
  computed: {
    price() {
      return {
        nominale: 'QUOTAZIONE NOMINALE',
        'live-market': 'Prezzo: ',
        storica: 'Prezzo: ',
      }[this.type];
    },
    buttonText() {
      return {
        nominale: 'ACQUISTA A ',
        'live-market': 'Procedi',
        storica: 'Calcola quotazione',
        sponsor: 'Avanti',
      }[this.type];
    },
  },
  methods: {
    sendTracking(clickEvent) {
      if (
        clickEvent &&
        window &&
        window.webtrekk_funcs &&
        typeof window.webtrekk_funcs.trackWebtrekkEvent === 'function'
      ) {
        window.webtrekk_funcs.trackWebtrekkEvent(clickEvent);
        window.webtrekk_funcs.sendWebtrekkEvents();
      }
    },
    onLiveMarketClick(event) {
      this.loadingLiveMarket = true;
      const evt = event.currentTarget.dataset.eventClick;
      this.sendTracking(evt);
      this.$emit('submit-form', 'live-market');
    },
    onMainClick(event) {
      this.loadingMain = true;
      const evt = event.currentTarget.dataset.eventClick;
      this.sendTracking(evt);
      this.$emit('submit-form', this.type);
    },
    setupViewportTracking() {
      if (!('IntersectionObserver' in window)) return;
      const obs = new IntersectionObserver(
        (entries, o) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const el = entry.target;
              const imps = el.dataset.eventImps;
              this.sendTracking(imps);
              o.unobserve(el);
            }
          });
        },
        { threshold: 0.5 },
      );
      if (this.$refs.liveMarketButton) obs.observe(this.$refs.liveMarketButton);
      if (this.$refs.mainButton) obs.observe(this.$refs.mainButton);
    },
  },
  mounted() {
    this.$nextTick(this.setupViewportTracking);
  },
};
</script>

<style scoped>
.button-primary,
.button-buy-nominal {
  min-width: 199px;
  min-height: 50px;
}

.button-buy-nominal {
  background-color: #ffffff;
  color: #d20b12;
  box-shadow: 0px 2px 2px #00000029;
  border-radius: 4px;
  border: none;
  padding: 13px 20px;
  text-align: center;
  cursor: pointer;
  text-decoration: none;
  font: normal normal 600 16px / 19px Montserrat;
  letter-spacing: 0px;
}
.bg-red {
  background-color: #d20b12;
}

.button-buy-nominal:hover {
  background-color: #d20b12;
  color: #ffffff;
}

.disabledBtn {
  opacity: 0.65;
  pointer-events: none;
}

.fs-14 {
  font-size: 14px;
}
.mr-45 {
  margin-right: 45px;
}
.line-through {
  text-decoration: line-through;
  text-decoration-thickness: 2px;
  background-color: transparent;
}
</style>



// WEBPACK FOOTER //
// resources/js/app/components/BuyQuotationBtn.vue